import { dependencyMatches } from "../Validation/dependencyUtils";
import { SurveyCreator } from "survey-creator-react";
export function registerSurveyEvents(survey: any) {
  survey.onValueChanged.add((sender: any, change: any) => {
    survey.getAllQuestions().forEach((q: any) => {
      if (q.dependsOn !== change.name) return;

      const matches = dependencyMatches(
        sender.getValue(q.dependsOn),
        q.dependsValue
      );

      if (q.dependencyAction === "show") {
        q.visible = matches;
      }

      if (q.dependencyAction === "enable") {
        q.enabled = matches;
      }

      if (q.dependencyAction === "require") {
        q.isRequired = matches;
      }
    });
  });
}

export function registerTemplateGenerators(creator: SurveyCreator) {
  const handlePropertyChange = (_: any, options: any) => {
    const obj = options.obj;
    if (!obj) return;

    // --- 1. CONDITIONAL RANGE TEMPLATE GENERATION ---
    if (options.propertyName === "conditionalRangeShow") {
      if (options.newValue === false) {
        obj.conditionalRangeRules = "";
        return;
      }

      if (options.newValue === true && obj.conditionalRangeBaseQuestion) {
        const baseQuestion = creator.survey.getQuestionByName(obj.conditionalRangeBaseQuestion);

        if (baseQuestion && ["dropdown", "radiogroup"].includes(baseQuestion.getType())) {
          const choices = baseQuestion.choices || [];
          const template = choices.map((choice: any) => {
            const optionValue = typeof choice === "string" ? choice : (choice.value || choice.text);
            return `${optionValue}: 0-100`;
          }).join('\n');

          obj.conditionalRangeRules = template;
        }
      }
    }

    // --- 2. ROW RANGE (MATRIX) TEMPLATE GENERATION ---
    if (options.propertyName === "rowRangeShow") {
      if (options.newValue === false) {
        obj.rowRangeRules = "";
        return;
      }

      if (options.newValue === true) {
        // Find the matrix question by name
        const baseQuestion = creator.survey.getQuestionByName(obj.name);

        if (baseQuestion) {
          const cols = baseQuestion.columns || (baseQuestion.getColumns ? baseQuestion.getColumns() : null);

          if (Array.isArray(cols) && cols.length > 0) {
            const template = cols.map((col: any) => {
              const colName = col.name || col.title || (col.cellType ? col.cellType : "");
              return `${colName}: 0-100`;
            }).join('\n');
            obj.rowRangeRules = template;
          }
        }
      }
    }
  };

  creator.onPropertyValueChanging.add(handlePropertyChange);

  // Return the cleanup function so the component can unregister it
  return () => {
    creator.onPropertyValueChanging.remove(handlePropertyChange);
  };
}

export function registerPropertyEditorSync(creator: any) {
  creator.onPropertyEditorCreated.add((sender: any, options: any) => {
    const propName = options.property.name;
    if (propName !== "compareValue" && propName !== "dependsSetValue" && propName !== "dependsValue") return;

    const el = options.obj; // The question being edited
    const ed = options.editor; // The editor in the property panel

    const setupEditor = () => {
      // Logic for dependsValue: Look at the "dependsOn" question
      if (propName === "dependsValue" && el.dependsOn) {
        const dependsOnQuestion = creator.survey.getQuestionByName(el.dependsOn);
        if (dependsOnQuestion) {
          const type = dependsOnQuestion.getType();

          // If base is choice-based, force editor to be a dropdown
          if (["dropdown", "radiogroup", "checkbox", "tagbox"].includes(type)) {
            // Important: We must set choices for the editor to behave like a dropdown
            ed.choices = dependsOnQuestion.choices || [];
          } else {
            ed.inputType = dependsOnQuestion.inputType || "text";
          }
        }
      }
      // Logic for compareValue/dependsSetValue: Look at the CURRENT question
      else {
        ed.inputType = el.inputType || "text";
      }
    };

    // Initial setup when the panel opens
    setupEditor();

    // 🔥 THE FIX: Listen for changes to "dependsOn" while the panel is open
    el.onPropertyChanged.add((sender: any, propertyOptions: any) => {
      if (propertyOptions.name === "dependsOn") {
        setupEditor();
      }
    });
  });
}